// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ak tu","wrapperNeon":"Al tG","ribbon":"Am tD","title":"An tw","seasons":"Ao tB","genres":"Ap tC","buttonWrapper":"Aq ty","button":"Ar tz","buttonNeon":"As tH"};